import { database } from '../lib/storage/global';
import { ScreenshotConnectionPlugin } from '@/mobile/ScreenshotConnection';
import useScreenshotsStore from '../store/screenshots';
import useUIStore from '../store/ui';
import { isInMobile } from './mobile';
import { useAssistantStore } from '@fabric-app/business/assistant/stores/assistantStore';
import { getPersisterQueriesStoreName } from '@fabric-app/compat';
import { assistantStoreName } from '@fabric-app/business/assistant/hooks/useChatbot';

export const resetStores = async () => {
  useUIStore.getState().reset();
  useScreenshotsStore.getState().reset();
  useAssistantStore.getState().reset();

  if (database) {
    database.clear(getPersisterQueriesStoreName());
    database.clear(assistantStoreName);
  }

  if (isInMobile()) await ScreenshotConnectionPlugin.reset();
};
